<template>
  <div class="grid grid-cols-1 gap-4 w-full shrink-0">
    <div class="bg-no-repeat bg-cover bg-center min-h-100 w-full flex flex-col justify-center items-center"
         :class="`bg-[url('${assetsPath}img/bg-certificado-mais-ifmg.jpg')]`">
      <UIcon name="ph:warning-circle" class="text-[80px] lg:text-[100px] text-[#F39C12]" />
      <p class="text-xl lg:text-2xl font-bold my-2 lg:my-4" data-cy="register-fullname-paragraf">
        {{ store.state.name }} {{ store.state.surname }}
      </p>
      <div class="text-center text-gray-800">Seu nome será exibido EXATAMENTE assim nos certificados.</div>
      <div class="font-bold sm:py-2 py-4 text-primary text-center">Ele não poderá ser alterado posteriormente.</div>

      <AppButtonRed :block="false" @click="store.currentStep = 1" data-cy="register-edit-fullname-button">
        Corrigir nome
      </AppButtonRed>
    </div>
  </div>
</template>

<script setup lang="ts">
const store = useRegisterStore()
const config = useRuntimeConfig()
const assetsPath = config.public.assetsPath
</script>